module.exports = __webpack_public_path__ + "img/1.5cf91e3b.jpg";